import { StyledTooltipWrapper } from './TooltipWrapper.style';
import { StyledTooltipTitle } from './TootltipTitle.style';

export interface TooltipWrapperProps {
  title?: string;
  children: React.ReactNode | React.ReactNode[];
}

export const TooltipWrapper = (props: TooltipWrapperProps) => {
  const { title, children, ...rest } = props;

  return (
    <StyledTooltipWrapper {...rest}>
      {title && <StyledTooltipTitle>{title}</StyledTooltipTitle>}
      {children}
    </StyledTooltipWrapper>
  );
};
